import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Protected — RBAC route guard.
 * Renders its children only if the signed-in user holds the required
 * permission; otherwise redirects to the dashboard. Pass `permission`
 * for a single key, or `anyOf` for a list (passes if the user has any).
 */
export default function Protected({ permission, anyOf, children }) {
  const { loading, can, canAny } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-amber-500" />
      </div>
    );
  }

  const allowed = anyOf
    ? canAny(anyOf)
    : permission
      ? can(permission)
      : true;

  if (!allowed) return <Navigate to="/" replace />;
  return children;
}
